export default "__VITE_ASSET__EO4slnQF__"